export enum Access {
  CREATE = 'create',
  READ = 'read',
  WRITE = 'write',
  DELETE = 'delete',
}
